import { render } from "./ChatFolders.vue?vue&type=template&id=1f9897ee&scoped=true"
import script from "./ChatFolders.vue?vue&type=script&lang=js"
export * from "./ChatFolders.vue?vue&type=script&lang=js"

import "./ChatFolders.vue?vue&type=style&index=0&id=1f9897ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9897ee"]])

export default __exports__